import { render, staticRenderFns } from "./storeData.vue?vue&type=template&id=d49028de&scoped=true&"
import script from "./storeData.vue?vue&type=script&lang=js&"
export * from "./storeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49028de",
  null
  
)

export default component.exports